<template>
  <div class="page my-page-box">
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow" :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <div class="main-area">
      <div class="header-area">
        <el-button style="margin-left: 10px;height: 38px; width: 98px" round type="success" @click="onAddVisitor">
          新增访客
        </el-button>
        <el-button v-if="hasCommitPermission" type="danger" plain size="mini" style="margin-left: 30px" @click="cleartextShow('常邀访客')">明文查看
        </el-button>
      </div>
      <el-table class="drawer-table" :data="tableData" border>
        <el-table-column prop="name" label="访客姓名" width="180px"></el-table-column>
        <el-table-column prop="tel" label="手机号码" width="180px" v-slot="{row}">
          <template v-if="phoneNumShow">{{ row.tel }}</template>
          <template v-else>{{ row.tel | phNoFilter }}</template>
        </el-table-column>
        <el-table-column prop="company" label="访客公司"></el-table-column>
        <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
          <template v-slot="scope">
            {{ scope.row.ic  | icNoFilter}}
          </template>
        </el-table-column>
        <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 "></el-table-column>

        <el-table-column label="操作" width="150px">
          <template v-slot="scop">
            <el-button type="primary" size="mini" @click="onShowTableDel(scop.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="onDrawTableDel(scop.row)" :disabled="!hasCommitPermission">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="prev, pager, next"
                       :total="pagiTotal"
                       :page-size="pagiPageSize"
                       :pager-count="5"
                       :current-page.sync="index"
                       @current-change="handlePagination">
        </el-pagination>
      </div>
    </div>

    <el-drawer title="访客信息" class="drawer-box" :visible.sync="visitorDrawerShow" :with-header="false">
      <div class="drawer-head">
        <div class="drawer-title">访客信息</div>
        <button @click="visitorDrawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-content">
        <el-form label-width="90px" v-model="selectRow" :rules="addRules">
          <el-form-item label="访客姓名" prop="name">
            <el-input v-model="selectRow.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel">
            <el-input v-model="selectRow.tel"></el-input>
          </el-form-item>
          <el-form-item label="访客公司" prop="company">
            <el-input v-model="selectRow.company"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="ic" v-if="visitorSetting.idCardNo !== 1">
            <el-input v-model="selectRow.ic" placeholder="请输入身份证号" class="table-width-drawer"></el-input>
          </el-form-item>
          <el-form-item label="访客国籍" prop="nationality" v-if="visitorSetting.nationality !== 1">
            <el-input v-model="selectRow.nationality" placeholder="请输入国籍" class="table-width-drawer"></el-input>
          </el-form-item>

          <el-form-item label="备注信息">
            <el-input v-model="selectRow.comments"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="updateVisitor" type="primary">修改</el-button>
        <el-button size="mini" @click="visitorDrawerShow = false">返回</el-button>
      </div>
    </el-drawer>


    <el-drawer title="新增访客" class="drawer-box" :visible.sync="addVisitorShow" :with-header="false">
      <div class="drawer-head">
        <div class="drawer-title">新增访客</div>
        <button @click="addVisitorShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-content">
        <el-form v-model="addForm" :rules="addRules" label-width="80px">
          <el-form-item label="访客姓名" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel">
            <el-input v-model="addForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="访客公司" prop="company">
            <el-input v-model="addForm.company"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="ic" v-if="visitorSetting.idCardNo !== 1">
            <el-input v-model="addForm.ic" placeholder="请输入身份证号" class="table-width-drawer"></el-input>
          </el-form-item>
          <el-form-item label="访客国籍" prop="nationality" v-if="visitorSetting.nationality !== 1">
            <el-input v-model="addForm.nationality" placeholder="请输入国籍" class="table-width-drawer"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="addVisitorShow = false">返回</el-button>
        <el-button size="mini" type="success" @click="addVisitorClick">新增</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>

import {addUsualVisitor, deleteUsualVisitor, getUsualVisitor, updateUsualVisitor} from "@/api/mobile/mobile-usual-api";
import {mixin_clearPhoneNumShow, mixin_table} from "@/utils/mixin";
import {mobileUpdateVisitor, visitorAdd} from "@/api/mobile/mobile-visitor-api";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {getInviteVisitorFormSettingWithMobile} from "@/api/mobile/mobile-setting-api";

export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_table, mixin_clearPhoneNumShow],
  data() {
    return {
      visitorDrawerShow: false,
      selectRow: {name: "", tel: "", company: "", ic: "", nationality: ""},
      addForm: {name: "", tel: "", company: "", ic: "", nationality: "",},
      addRules: {
        name: [{required: true, message: '请输入访客姓名'}],
        tel: [{required: true, message: '请输入手机号码'}],
        company: [{required: true, message: '请输入访客公司'}],
      },
      addVisitorShow: false,
      visitorSetting: {
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
      },
    };
  },

  mounted() {
    this.requestUsualVisitorList()


    getInviteVisitorFormSettingWithMobile().then(({data}) => {
      console.log("getInviteVisitorFormSettingWithMobile", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "VISITOR_INVITE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.visitorSetting.idCardNo = content.idCardNo
              this.visitorSetting.nationality = content.nationality
            }
          }
        })
      }
      if (this.visitorSetting.idCardNo === 3) {
        this.addRules.ic = [{required: true, message: '请输入身份证号'}]
      }
      if (this.visitorSetting.nationality === 3) {
        this.addRules.nationality = [{required: true, message: '请输入国籍'}]
      }
    }).catch((err) => {
      this.showNetErrMsg(err)
    })
  },

  methods: {
    requestUsualVisitorList() {
      getUsualVisitor().then(({data}) => {
        console.log("getUsualVisitor", data)
        if (data.code === 200) {
          this.tableAllData = data.data
          this.tableShowData = this.tableAllData
          this.initPaginationTable()
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },
    onShowTableDel(row) {
      this.selectRow = {...row}
      this.visitorDrawerShow = true
      // if (!this.phoneNumShow) {
      //   this.selectRow.tel = this.toFixShowTel(this.selectRow.tel)
      // }
    },
    onDrawTableDel(row) {
      deleteUsualVisitor(row.code).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("删除成功")
          this.historyVisitor = this.historyVisitor.filter((item) => {
            return item.id !== row.id
          })
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },

    onAddVisitor() {
      this.addVisitorShow = true
    },

    addVisitorClick() {
      if (!this.addForm.name) {
        this.$message.error("请输入姓名")
        return
      }
      if (!this.addForm.tel) {
        this.$message.error("请输入手机号")
        return
      }
      if (!this.addForm.company) {
        this.$message.error("请输入公司")
        return
      }
      if (this.visitorSetting.idCardNo === 3 && !this.addForm.ic) {
        this.$message.error("请输入身份证号")
        return
      }
      if (this.visitorSetting.nationality === 3 && !this.addForm.nationality) {
        this.$message.error("请输入国籍")
        return
      }

      let find = this.tableAllData.find((item) => {
        return item.tel === this.addForm.tel
      })
      if (find) {
        this.doUpdateUsual(find)
        return
      }

      console.log("addVisitorClick param => ", this.addForm)
      let {name, tel, company, ic, nationality} = this.addForm
      visitorAdd(name, tel, company, ic, nationality).then(({data}) => {
        console.log("addVisitorClick result => ", data)
        if (data.code === 200) {
          this.doAddToUsual(data.data)
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })

    },

    doUpdateUsual(userInfo) {
      console.log("doUpdateUsual param => ", userInfo.code)
      updateUsualVisitor(userInfo.code).then(({data}) => {
        console.log("doUpdateUsual result => ", data)
        if (data.code === 200) {
          this.$message.success("用户已添加常访")
          this.addVisitorShow = false
          this.addForm = {name: "", tel: "", company: "", ic: "", nationality: "",}
          this.tableAllData = this.tableAllData.filter((item) => {
            return item.tel !== userInfo.tel
          })
          this.tableAllData.unshift(userInfo)
          this.tableShowData = this.tableAllData
          this.initPaginationTable()
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },

    doAddToUsual(userInfo) {
      addUsualVisitor(userInfo.code).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("新增成功")
          this.addVisitorShow = false
          this.requestUsualVisitorList()
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },
    updateVisitor() {

      if (this.visitorSetting.idCardNo === 3 && !this.selectRow.ic) {
        this.$message.error("请输入身份证号")
        return
      }
      if (this.visitorSetting.nationality === 3 && !this.selectRow.nationality) {
        this.$message.error("请输入国籍")
        return
      }
      let postData = {
        id: this.selectRow.id,
        name: this.selectRow.name,
        tel: this.selectRow.tel,
        company: this.selectRow.company,
        ic: this.selectRow.ic,
        nationality: this.selectRow.nationality,
        comments: this.selectRow.comments,
      }

      mobileUpdateVisitor(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("修改成功")
          this.visitorDrawerShow = false
          this.requestUsualVisitorList()
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },
  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "STAFF":
          return true
        default:
          return false
      }
    }
  },
}
</script>

<style lang="less" scoped>

.header-area {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
}

.drawer-content .el-form-item {
  margin: 20px;

}

.my-page-box {
  padding-left: 10vw;
  padding-right: 10vw;
}
</style>
